export default __webpack_public_path__ + "static/aboutImage-82fda3cb85e7ff433b3bb15b4fac535d.svg";